'use strict';

define(['app', 'productAddToBasket', '$window'], function (app, productAddToBasket, $window) {

  var STICKY_BUTTON_BOTTOM_PADDING = 8;

  var productAddToBasketButton = function productAddToBasketButton() {
    var component = this;

    var _config = {
      selectors: {
        component: '[data-component=productAddToBasketButton]',
        productAddToBasketButton: '[data-product-add-to-basket-button]',
        isSticky: '[data-issticky]'
      },
      attr: {
        hasDigitalOrPhysicalOption: 'data-has-digital-or-physical-sku',
        hasAlternativeWording: 'data-has-alternative-wording-enabled'
      },
      classes: {
        stickClass: 'productAddToBasket-sticky'
      },
      subscribeChannels: {
        addToBasketButton: 'productAddToBasketButton/newButton'
      }
    };

    var _init = function _init(element) {
      component.element = element;
      var addToBasketButtonSubscribe = app.subscribe(component.config.subscribeChannels.addToBasketButton, component.getNewButton);

      component.checkSubscribeMessages(addToBasketButtonSubscribe, component.getNewButton);
      component.addEventListeners();

      return component;
    };

    var _addEventListeners = function _addEventListeners() {
      if (component.element && component.element.querySelector(_config.selectors.isSticky)) {
        $window.addEventListener('scroll', component.callStickEvent);
        component.callStickEvent();
      }
    };

    var _callStickEvent = function _callStickEvent() {
      var wrapper = component.getStickyBtnWrapper();
      component.stickEvent(wrapper);
    };

    var _getStickyBtnWrapper = function _getStickyBtnWrapper() {
      var stickyBtn = document.querySelector(_config.selectors.isSticky);
      if (stickyBtn) {
        return stickyBtn.parentElement;
      }
      return null;
    };

    var _stickEvent = function _stickEvent(stickyBtnWrapper) {
      if (stickyBtnWrapper) {
        var windowHeight = $window.innerHeight;
        var stickPosition = stickyBtnWrapper.getBoundingClientRect().bottom;
        if (stickPosition < windowHeight && !stickyBtnWrapper.classList.contains(_config.classes.stickClass)) {
          stickyBtnWrapper.classList.add(_config.classes.stickClass);
        }

        var unstickPosition = stickyBtnWrapper.parentElement.getBoundingClientRect().top + stickyBtnWrapper.clientHeight;
        if (unstickPosition >= windowHeight && stickyBtnWrapper.classList.contains(_config.classes.stickClass)) {
          stickyBtnWrapper.classList.remove(_config.classes.stickClass);
        }
      }
    };

    var _newButtonReceived = function _newButtonReceived(newButtonData) {
      var newContainer = document.createElement('div');
      newContainer.innerHTML = newButtonData;
      var newElem = newContainer.querySelector(component.config.selectors.component);
      var hasDigitalOrPhysicalOption = newElem.hasAttribute(component.config.attr.hasDigitalOrPhysicalOption);

      if (hasDigitalOrPhysicalOption) {
        var parentNode = component.element.parentNode;

        parentNode.replaceChild(newElem, component.element);
        component.element = newElem;
      }

      var newButton = newElem.querySelector(component.config.selectors.productAddToBasketButton);

      var oldButton = component.element.querySelector(component.config.selectors.productAddToBasketButton);

      if (newButton) {
        component.element.removeChild(oldButton);
        component.element.appendChild(newButton);
        var newButtonElem = newButton.querySelector('[data-component=productAddToBasket]');
        if (newButtonElem) {
          var addToBasketSpan = newContainer.querySelector('[data-linked-product]');
          if (addToBasketSpan) {
            var productId = addToBasketSpan.getAttribute('data-product-id');
          }
          newButtonElem.componentObject = new productAddToBasket().init(newButtonElem, productId);
        }
      }

      var hasQuantity = newElem.getAttribute('data-has-quantity-input') === 'true';
      app.publish('productQuantity/updateVisbilty', hasQuantity);
      component.callStickEvent();
    };

    var _getNewButton = function _getNewButton(productId) {
      var useAlternativeWording = void 0;
      if (component.element) {
        useAlternativeWording = component.element.hasAttribute(component.config.attr.hasAlternativeWording);
      }

      var buttonURL = '/' + productId + '.addtobasketbutton';

      if (useAlternativeWording) {
        buttonURL += '?useAlternativeCTAWording=true';
      }

      app.ajax.get({
        url: buttonURL,
        success: component.newButtonReceived,
        error: component.newButtonErrorHandler
      });
    };

    var _newButtonErrorHandler = function _newButtonErrorHandler() {
      console.error('ERROR: Could not retrieve child product add to basket button');
    };

    var _checkSubscribeMessages = function _checkSubscribeMessages(subscription, callback) {
      if (subscription.messages && subscription.messages.length > 0) {
        var lastItem = subscription.messages.slice(-1)[0];
        callback(lastItem);
      }
    };

    component.init = _init;
    component.config = _config;
    component.addEventListeners = _addEventListeners;
    component.stickEvent = _stickEvent;
    component.newButtonReceived = _newButtonReceived;
    component.getNewButton = _getNewButton;
    component.newButtonErrorHandler = _newButtonErrorHandler;
    component.checkSubscribeMessages = _checkSubscribeMessages;
    component.getStickyBtnWrapper = _getStickyBtnWrapper;
    component.callStickEvent = _callStickEvent;

    return component;
  };

  return productAddToBasketButton;
});
//# sourceMappingURL=productAddToBasketButton.js.map
